import React from 'react';
import withTranslations from '../translations/translations.wrapper.jsx';
import './ErrorPage.scss';
import {Link} from "react-router-dom";
import {isRenamedToApprovals} from "utils/productName.function";


/**
 * @param props
 *    .errorType ~ string, used for translation keys and css class for image
 *    .translate ~ function, used for translating
 *    .msg ~ string, optional, if provided, it will be used for error detail in the translated string
 *    .action ~ node, optional, rendered in place of the default button for this error type
 * @return react component
 */
const ErrorPageRaw = (props) => {

    const msgKey = props.errorType === 'accessDenied' && isRenamedToApprovals() ? ".msgApprovals" : ".msg";
    const translationKey = props.msg ?  "errorPage." + props.errorType+".msgWithError" : "errorPage." + props.errorType + msgKey;
    const msg = props.translate(translationKey, props.msg);

    const onReload = () => {
        window.location.reload();
    }

    return (
        <div id="error-message-container">
            <span className={"error-image " + props.errorType} />
            <div className="row">
                <div className="col-md-4">
                    <div className="error-title">{props.translate("errorPage." + props.errorType+".title")}</div>
                    <div className="error-body">{msg}</div>
                    {props.action ? props.action :
                        props.errorType === 'serverError' || props.errorType === 'serverDown' ?
                            // serverDown is shown in place when /startup fails, before the app is initialized -
                            // a full reload re-attempts startup, whereas an in-app link would just re-render this page
                            <div>
                                <button type="button"
                                        className="btn btn-primary"
                                        onClick={onReload}>
                                    {props.translate("errorPage.refresh")}
                                </button>
                            </div> :
                            // accessDenied has no action: going home would re-trigger /startup and loop on 403
                            props.errorType !== 'accessDenied' &&
                            <Link to='/'>
                                <button type="button"
                                        className="btn btn-primary">
                                    {props.translate("errorPage.goToHomepage")}
                                </button>
                            </Link>}
                </div>
            </div>
        </div>
    );
};

const ErrorPageWithTranslations = withTranslations(ErrorPageRaw);

/**
 * for anyone who wants to use this class for error reporting
 *
 * if props.translate is provided, it will be used for localisation
 * @param props
 */
export const LocalisedErrorPage = (props) => {
    if(props.translate) {
        return <ErrorPageRaw {...props} />
    } else {
        return <ErrorPageWithTranslations {...props} />
    }
};

// default #404 page
export const NotFound = (props) => {
    return ( <LocalisedErrorPage {...props} errorType="notFound" />);
};

// default error reporting when 'page content component' fails to load necessary data to show anything
export const ServerError = (props) => {
    return ( <LocalisedErrorPage {...props} errorType="serverError" />);
};

/**
 * error page when we're unable to load /startup data
 * @param props
 * @return react component
 * @constructor
 */
export const WithoutStartup = (props) => {
    return ( <LocalisedErrorPage errorType="serverDown" {...props} />);
};

// shown when /startup returns 403 - user has no access rights to Approval
export const AccessDenied = (props) => {
    return ( <LocalisedErrorPage {...props} errorType="accessDenied" />);
};




